/**
 * Atlas PM · 权限配置 · 数据 hooks（P4.4）
 *
 * ⚠️ 本任务只落在 features/settings 目录内，故 query key 就地定义，
 *    不改动共享的 api/queryKeys.ts（避免与并发任务产生冲突）。
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { roleApi } from './api';

/** 本模块 query key 工厂 */
export const roleKeys = {
  all: ['system', 'roles'] as const,
  roles: () => ['system', 'roles', 'list'] as const,
  permissions: () => ['system', 'permissions'] as const,
};

export function useRoles() {
  return useQuery({
    queryKey: roleKeys.roles(),
    queryFn: () => roleApi.listRoles(),
  });
}

export function usePermissions() {
  return useQuery({
    queryKey: roleKeys.permissions(),
    queryFn: () => roleApi.listPermissions(),
    // 权限目录基本不变，避免切换标签反复请求
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateRolePermissions() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ roleId, permissionCodes }: { roleId: string; permissionCodes: string[] }) =>
      roleApi.updatePermissions(roleId, permissionCodes),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: roleKeys.roles() });
    },
  });
}
